import { OFFSET_SIZE } from './constants'

export const getTotalChildrenWidth = (refWidths: number[], columnGap: number) =>
  refWidths.reduce<number>((totalWidth, childWidth) =>
    totalWidth + childWidth + OFFSET_SIZE + columnGap,
  0)
